import {useApi} from "../Api";
import {AncillaryExceptionEntityResponse} from "../types/ancillaryException";
import {ExceptionListEntityResponse} from "../types/exceptionList";
import {ExceptionListAncillaryExceptionAssociation} from "../types/exceptionListAncillaryExceptionModel";
import {
    AmountExtraKmResponse,
    AncillaryExceptionAssociationRequest,
    AncillaryExceptionPlanRequest,
    CarGroupRentalPeriodResponse,
    ExceptionPlanRequest,
    ExcessPlanDetailResponse,
    ExcessPlanResponse
} from "../types/productPlan";
import {RateEntityResponse} from "../types/rate";

export const useProductPlanRepository = () => {
    const {GET, POST, PUT} = useApi();

    const PATH = "/pricing/rate";
    const EXCEPTIONPATH = "/pricing/exception-list"
    const EXCESSPATH = "pricing/excess-group"

    function getRateCommercialCategoryLocationGroup(locationId: number, productCode: string, dealers: string): Promise<RateEntityResponse[]> {
        return GET(`${PATH}/get-rates-product-code-location-group?locationGroupId=${locationId}&productCode=${productCode}&dealers=${dealers}`)
    }

    function getCarGroupRentalPeriodByRate(rateId: number): Promise<CarGroupRentalPeriodResponse> {
        return GET(`${PATH}/get-car-group-rental-period-by-rate?rateId=${rateId}`)
    }

    function getPriceAndExtraKm(rateId: number, carGroup: string, rentalPeriodId: number): Promise<AmountExtraKmResponse> {
        return GET(`${PATH}-detail/details-for-rate-plan?rateId=${rateId}&carGroup=${carGroup}&rentalPeriodId=${rentalPeriodId}`)
    }

    function getExceptionPlanByProductCodeAndLocation(locationId: number, productCode: string, dealers: string): Promise<ExceptionListEntityResponse> {
        return GET(`${EXCEPTIONPATH}/get-by-product-code-location-group-exception-plan?locationGroupId=${locationId}&productCode=${productCode}&dealers=${dealers}`)
    }

    function createExceptionPlan(body: ExceptionPlanRequest): Promise<ExceptionListEntityResponse> {
        return POST(`${EXCEPTIONPATH}/create-exception-plan`, body)
    }

    function getAncillaryExceptionByExceptionList(exceptionListId: number): Promise<AncillaryExceptionEntityResponse[]> {
        return GET(`${EXCEPTIONPATH}-exception/ancillary-exception-by-exception-list?exceptionListId=${exceptionListId}`)
    }

    function createNewAncillaryException(body: AncillaryExceptionPlanRequest): Promise<AncillaryExceptionEntityResponse> {
        return POST(`pricing/ancillary-exception/create-exception-plan`, body)
    }

    function putAssociateExceptions(body: AncillaryExceptionAssociationRequest): Promise<ExceptionListAncillaryExceptionAssociation[]> {
        return PUT(`${EXCEPTIONPATH}-exception/associations`, body)
    }

    function getExcessGroupByProductCodeAndLocation(locationGroup: number, productCode: string, dealers: string, legalEntities: string): Promise<ExcessPlanResponse> {
        return GET(`${EXCESSPATH}/active-excess-groups-by-product-code-location-group?productCode=${productCode}&locationGroup=${locationGroup}&dealers=${dealers}&legalEntities=${legalEntities}`)
    }

    function getExcessGroupDetail(excessGroupId: number, productCode: string, locationGroupId: number, carGroup: string): Promise<ExcessPlanDetailResponse[]> {
        return GET(`${EXCESSPATH}-detail/details-for-excess-plans?excessGroupId=${excessGroupId}&productCode=${productCode}&locationGroupId=${locationGroupId}&carGroup=${carGroup}`)
    }


    return {
        getRateCommercialCategoryLocationGroup,
        getCarGroupRentalPeriodByRate,
        getPriceAndExtraKm,
        getExceptionPlanByProductCodeAndLocation,
        createExceptionPlan,
        getAncillaryExceptionByExceptionList,
        createNewAncillaryException,
        putAssociateExceptions,
        getExcessGroupByProductCodeAndLocation,
        getExcessGroupDetail
    };
};

